<div class="sync-audit-page">
  <div class="page-header">
    <div>
      <p class="eyebrow">Database metrics</p>
      <h1>Sync Audit</h1>
      <p class="description">Reconciled baselines are compared separately from work waiting to sync to Salesforce.</p>
    </div>
  </div>

  @if (error) {
    <div class="error-banner">
      <span>{{ error }}</span>
      <p-button label="Retry" icon="pi pi-refresh" severity="danger" [outlined]="true" [loading]="loading" [disabled]="loading" (onClick)="retry()" />
    </div>
  }

  @for (group of groups; track group.title) {
    <section class="audit-group" [attr.aria-label]="group.title">
      <div class="audit-group__heading">
        <span class="audit-group__icon audit-group__icon--{{ group.accent }}"><i [class]="group.icon"></i></span>
        <h2>{{ group.title }}</h2>
      </div>

      @if (group.baseline.length > 0) {
        <div class="audit-subsection">
          <div class="audit-subsection__heading">
            <h3>Reconciled baseline</h3>
            <span class="baseline-badge">Comparison</span>
          </div>
          <div class="metric-grid">
            @for (metric of group.baseline; track metric.awsId) {
              <section class="metric-card card">
                @if (loading) {
                  <div class="metric-card__loading"><p-skeleton width="8rem" height="2rem" /><p-skeleton width="12rem" height="1rem" /><p-skeleton width="10rem" height="1rem" /></div>
                } @else {
                  <div class="metric-card__rows">
                    <div class="metric-card__row"><div class="metric-card__row-label">AWS</div><div class="metric-card__row-name">{{ formatFriendlyName(metric.aws) }}</div><div class="metric-card__row-value">{{ formatValue(metric.aws, metric.format) }}</div></div>
                    <div class="metric-card__row"><div class="metric-card__row-label">Salesforce</div><div class="metric-card__row-name">{{ formatFriendlyName(metric.salesforce) }}</div><div class="metric-card__row-value">{{ formatValue(metric.salesforce, metric.format) }}</div></div>
                    <div class="metric-card__difference metric-card__difference--{{ comparisonStatus(metric) }}"><i [class]="comparisonStatus(metric) === 'match' ? 'pi pi-check-circle' : comparisonStatus(metric) === 'mismatch' ? 'pi pi-exclamation-triangle' : 'pi pi-info-circle'"></i><span>{{ comparisonLabel(metric) }}</span></div>
                    @if (showPendingForBaseline(group, metric)) {
                      <div class="pending-inline">
                        <span class="pending-badge"><i class="pi pi-clock"></i> Pending sync</span>
                        @for (pending of pendingForBaseline(group, metric); track pending.id) {
                          <span class="pending-inline__metric">{{ pendingLabel(pending) }}: <strong>{{ formatValue(pending.entry, pending.format) }}</strong></span>
                        }
                        <span class="pending-inline__helper">Excluded from the reconciled comparison until Salesforce confirms the sync.</span>
                      </div>
                    }
                  </div>
                }
              </section>
            }
          </div>
        </div>
      }

      @if (group.baseline.length === 0 && !loading && hasPendingCount(group)) {
        <div class="pending-inline pending-inline--standalone">
          <span class="pending-badge"><i class="pi pi-clock"></i> Pending sync</span>
          @for (metric of group.pending; track metric.id) {
            <span class="pending-inline__metric">{{ pendingLabel(metric) }}: <strong>{{ formatValue(metric.entry, metric.format) }}</strong></span>
          }
        </div>
      }
    </section>
  }

</div>
